import { api } from '../api';
import { User } from '../../entities/User';

/**
 * `institutionId` vai **fora** do `userRequest`, e não é campo do usuário: o vínculo
 * usuário↔instituição vive em `institution_users` no back (tarefa 0.3 da Fase 0), que
 * é a autoridade do escopo por instituição — não há coluna em `users`.
 *
 * Obrigatório para papel de equipe e **recusado com 400** para `administrator`, o
 * único papel cross-tenant (0.27). Quem monta o corpo é a tela de cadastro, que só
 * envia o campo quando o papel escolhido o admite.
 */
export const createUser = async (
  userRequest: User,
  createdUpdatedBy: string,
  institutionId?: string,
): Promise<User> => {
  const { data } = await api.post('/users', {
    userRequest,
    createdUpdatedBy,
    ...(institutionId ? { institutionId } : {}),
  });

  return data;
};
